import React from 'react';
import Footer from '../Footer/Footer';
import repairImage from '../../Assets/Images/services.jpg'; // Replace with an actual image or reuse aboutImage if needed

import './Services.css';

const Repair = () => {
  return (
    <div className="services-page-main-sub">
      <div className="services-content-box">
        <div className="services-top-row">
          <div className="services-text-left">
            <h1>Game Console & Computer Repair</h1>
            <p>
              Reliable repairs for video game consoles, vintage computers, and a wide variety of electronic devices. We expertly diagnose issues and provide quality fixes to keep your hardware running smoothly.
            </p>
            <p>
              From component replacements and trace repairs to complex diagnostics, Cowdog Tech delivers trusted service with precision and care.
            </p>
          </div>

          <div className="services-right-column">
            <div className="services-image-right">
              <img src={repairImage} alt="Game Console & Computer Repair" />
            </div>
          </div>
        </div>

        <div className="services-bottom-text">
          <p>
            Whether it's a vintage console needing restoration or a modern device with hardware issues, we bring years of PCB assembly and repair experience to every project.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Repair;
